import { heroData } from '@/mocks/homeData';

export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[650px] flex items-center bg-background-50 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="relative w-full px-4 md:px-6 py-16 md:py-20 max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs font-medium bg-primary-100 text-primary-700 rounded-full mb-4">
              {heroData.tag}
            </span>

            <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 leading-tight mb-4">
              {heroData.h1}
            </h1>

            <p className="text-base md:text-lg text-primary-500 font-medium mb-6">
              {heroData.slogan}
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              {heroData.intro}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              {heroData.stats.map((stat, i) => (
                <div key={i} className="text-center lg:text-left">
                  <div className="text-lg md:text-xl font-heading font-bold text-foreground-900">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-500 mt-0.5">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href={heroData.primaryCta.href}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                {heroData.primaryCta.label}
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href={heroData.secondaryCta.href}
                className="inline-flex items-center gap-2 px-6 py-3 border border-background-300 text-foreground-700 font-medium text-sm rounded-lg hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                {heroData.secondaryCta.label}
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[360px] md:w-[340px] md:h-[440px] lg:w-[400px] lg:h-[500px] rounded-2xl overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-primary-100/50 to-accent-100/40 rounded-2xl"></div>
              <img
                src={heroData.heroImage}
                alt="52吃瓜网 - 娱乐圈八卦资讯聚合平台主视觉"
                className="w-full h-full object-cover rounded-2xl relative z-10"
                onError={(e) => {
                  (e.target as HTMLElement).style.display = 'none';
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}